import request from '@/utils/request';
import Resource from '@/api/resource';

class appsResource extends Resource {
  constructor() {
    super('apps');
  }

  /** 获取应用-以及搜索 */
  getAppList(data) {
    return request({
      url: `/${this.uri}`,
      method: 'get',
      params: data,
    });
  }

  /** 新增应用 */
  addApp(data) {
    return request({
      url: `/${this.uri}`,
      method: 'post',
      data,
    });
  }

  /** 删除应用 */
  deleteApp(data) {
    return request({
      url: `/${this.uri}/delete`,
      method: 'POST',
      data: data,
    });
  }

  /** 更新应用 */
  editApp(data, id) {
    return request({
      url: `/${this.uri}/${id}`,
      method: 'put',
      data: data,
    });
  }
}

export { appsResource as default };
